import React from 'react';

import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';

const ProjectPersonalQualities = ({ project }) => project.personalQualities ? (
    <div className="pmb-block">
        <DefinitionHeader translate="project.personal_qualities" iconType="profile-text" />
        <div className="panel-view text-justify text-pre-space">
            { project.personalQualities }
        </div>
    </div>
) : null;

export default ProjectPersonalQualities;
